import { CheckboxCell } from "../components/TableComponents";

export const ITEMS_PER_PAGE = 5;

/**
 * Columnas originales de la tabla (mantener para compatibilidad)
 */
export const TABLE_COLUMNS = [
  { Header: "Nombre", accessor: "nombre", width: "20%" },
  { Header: "Documento", accessor: "documento", width: "12%" },
  { Header: "Email", accessor: "email", width: "18%" },
  { Header: "Edad", accessor: "edad", width: "8%" },
  { Header: "Género", accessor: "genero", width: "10%" },
  { Header: "Cargo", accessor: "cargo_aplicado", width: "15%" },
  { Header: "Acciones", accessor: "acciones", width: "17%" },
];

/**
 * Columnas mejoradas con los nuevos campos
 * Incluye: Checkbox, Empresa, Ajuste al Cargo,Indice de Integridad Laboral, Fecha
 */
export const ENHANCED_TABLE_COLUMNS = (allSelected, handleSelectAll) => [
  {
    Header: () => (
      <CheckboxCell checked={allSelected} onChange={handleSelectAll} />
    ),
    accessor: "checkbox",
    width: "3%",
  },
  { Header: "Nombre", accessor: "nombre", width: "12%" },
  { Header: "Documento", accessor: "documento", width: "9%" },
  { Header: "Email", accessor: "email", width: "14%" },
  { Header: "Edad", accessor: "edad", width: "5%" },
  { Header: "Género", accessor: "genero", width: "7%" },
  { Header: "Cargo", accessor: "cargo", width: "10%" },
  { Header: "Empresa", accessor: "empresa", width: "10%" },
  { Header: "Ajuste al Cargo", accessor: "ajuste_cargo", width: "8%" },
  {
    Header: "Indice de Integridad Laboral",
    accessor: "integridad_laboral",
    width: "10%",
  },
  { Header: "Fecha", accessor: "fecha", width: "7%" },
  { Header: "Acciones", accessor: "acciones", width: "8%" },
];

export const REPORT_SECTIONS = {
  PURPOSE: {
    title: "Propósito del Informe",
    content:
      "Este informe está diseñado para ofrecer una evaluación psicológica integral de los candidatos a través de la herramienta Quadrante H. El objetivo de la herramienta es identificar y mitigar riesgos potenciales, así como optimizar y potenciar el talento de su empresa, asegurando que cada candidato se ajuste perfectamente a los requisitos del cargo y a la cultura organizacional.",
  },
  TEST_DESCRIPTION: {
    title: "¿Qué Hace el Test?",
    content:
      "Cuadrante H es una herramienta avanzada de perfilación psicológica que proporciona un análisis completo y detallado del candidato en diversas áreas clave. El test está diseñado para ofrecer una visión profunda y holística del perfil psicológico y comportamental del candidato, abarcando los siguientes aspectos:",
    aspects: [
      {
        title: "1. Perfil de Personalidad:",
        points: [
          "Determina el tipo de personalidad del candidato y su ajuste a los distintos cuadrantes de competencias.",
          "Identifica rasgos distintivos de la personalidad que son cruciales para el desempeño en el puesto.",
        ],
      },
      {
        title: "2. Integridad y Ética:",
        points: [
          "Evalúa la legalidad y moralidad del candidato, asegurando que su comportamiento se alinee con los valores y normativas de la empresa.",
          "Analiza la propensión a la indiferencia y la corrupción para prevenir posibles riesgos.",
        ],
      },
      {
        title: "3. Riesgos Psicopatológicos:",
        points: [
          "Detecta la presencia de rasgos psicopáticos y otros rasgos de la triada oscura de la personalidad, proporcionando una visión clara sobre posibles riesgos futuros.",
        ],
      },
      {
        title: "4. Desempeño y Desarrollo:",
        points: [
          "Identifica las motivaciones internas y externas del candidato, así como sus límites y potencial de desarrollo.",
          "Evalúa cómo el candidato maneja situaciones de presión y estrés.",
          "Ofrece recomendaciones personalizadas de capacitación para optimizar las habilidades y competencias del candidato.",
        ],
      },
    ],
  },
  BENEFITS: {
    title: "Beneficios del Informe",
    items: [
      {
        title: "Clasificación Precisa:",
        description:
          "Ubica a cada candidato en el cuadrante ideal según sus habilidades y comportamientos.",
      },
      {
        title: "Detección Temprana:",
        description:
          "Identifica rasgos psicopatológicos y prevé problemas futuros.",
      },
      {
        title: "Desarrollo de Talento:",
        description:
          "Identifica motivaciones, límites bajo presión y potencial de desarrollo.",
      },
      {
        title: "Capacitación Personalizada:",
        description:
          "Ofrece opciones de formación para mejorar las debilidades del candidato.",
      },
      {
        title: "Selección Eficiente:",
        description:
          "Asegura que cada candidato se ajuste perfectamente a los requisitos del cargo y a la cultura de la empresa.",
      },
    ],
  },
};

export const NOTIFICATION_TYPES = {
  SUCCESS: "success",
  ERROR: "error",
  INFO: "info",
};

export const NOTIFICATION_TITLES = {
  [NOTIFICATION_TYPES.SUCCESS]: "Éxito",
  [NOTIFICATION_TYPES.ERROR]: "Error",
  [NOTIFICATION_TYPES.INFO]: "Información",
};

export const NOTIFICATION_ICONS = {
  [NOTIFICATION_TYPES.SUCCESS]: "check",
  [NOTIFICATION_TYPES.ERROR]: "warning",
  [NOTIFICATION_TYPES.INFO]: "info",
};
